/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { HOST_SERVER, LOCALSTORAGE_AUTH_KEY } from '../../../constants';
import s from './ModalFinalizado.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import redirectTo from '../../../utils/redirectTo';

class ModalFinalizado extends React.Component {
  constructor(props) {
    super(props);
    this.finalizar = this.finalizar.bind(this);
  }

  finalizar() {
    this.props.cleanLlamada();
    if (
      document.getElementById('localView') &&
      document.getElementById('localView').srcObject
    ) {
      document
        .getElementById('localView')
        .srcObject.getTracks()
        .forEach(track => track.stop());
      $('localView').srcObject = null;
    }
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const token = datos.token;
    const dataToken = {
      token,
    };
    $.ajax({
      url: `${generateAbsoluteUrl()}/renew-token`,
      global: false,
      type: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(dataToken),
      async: false,
      success: response => {
        if (response.data && response.data.token && response.data.exp) {
          const authData = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
          const authJson = JSON.parse(authData);
          authJson.token = response.data.token;
          authJson.exp = response.data.exp;
          localStorage.setItem('token', JSON.stringify(authJson.token));
          localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(authJson));
        }
      },
    });
    this.props.hideValidacionesTecnicas();
    redirectTo('/telemedicina');
  }

  goToTurnos() {
    this.props.cleanLlamada();
    this.props.hideValidacionesTecnicas();
    window.location.href = `${HOST_SERVER}smgnewsite/prepaga/turnos_online.php?origen=barIzq`;
  }

  render() {
    return (
      <div className={`${s.modalFinalizado} modal fade`} id="modalFinalizado">
        <div className={`${s.modalDialog} modal-dialog`} role="document">
          <div className={`${s.modalFinalizadoContent} modal-content`}>
            <div className={`${s.modalHeader} modal-header`}>
              <h5 className="modal-title">
                Muchas gracias por utilizar E-Consulta
                <span>Tal vez te interese.</span>
              </h5>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              {/*
              <button
                onClick={() => this.goToTurnos()}
                className={`${s.modalButtons}`}
              >
                <i className="fa fa-user-md" aria-hidden="true" />
                <p>Agendar turno presencial</p>
                
              </button>
              */}
              <button
                data-dismiss="modal"
                className={`${s.modalButtons}`}
                onClick={() => this.finalizar()}
              >
                <i className="fa fa-video-camera" aria-hidden="true" />
                <p>
                  Programar<br /> e-Consulta
                </p>
              </button>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                id="openModalButton"
                className={`${s.boton_rojo} btn btn-default text-center`}
                onClick={() => this.finalizar()}
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, telemedicinaActions)(
  withStyles(s)(ModalFinalizado),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalFinalizado/ModalFinalizado.js